import React from "react";
import PropTypes from "prop-types";
import { makeStyles, Tooltip } from "@material-ui/core";
import tooltipStyle from "assets/jss/material-dashboard-react/tooltipStyle.js";

const useStyles = makeStyles(tooltipStyle);
export default function CustomTooltip(props) {
  const { placement, ...rest } = props;
  const classes = useStyles();
  return <Tooltip placement={placement} classes={classes} {...rest} />;
}

CustomTooltip.defaultProps = {
  placement: "top",
};

CustomTooltip.propTypes = {
  placement: PropTypes.string,
  title: PropTypes.node,
  children: PropTypes.node,
  classes: PropTypes.object,
  style: PropTypes.object,
};
